import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../interfaces/IReduxState";
import { IOrderReport } from "../../pages/orderReport/IOrderReport";
import { FAILED } from "../login-and-create-password/login-reducer";

//item master list filter
const ListOrderDataReport = createSlice({
  name: "ListOrderDataReport",
  initialState: {} as IReduxState<IOrderReport[]>,
  reducers: {
    listOrderDataReportStart: (state, _) => {
      state.isLoading = true;
    },
    successListOrderDataReport: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

      action.payload?.result?.length === 0 && FAILED(action.payload);
    },
    failureListOrderDataReport: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      FAILED(action.payload);
    },
    clearListOrderDataReport: (state) => {
      state.data = {};
    },
  },
});

export const {
  listOrderDataReportStart,
  successListOrderDataReport,
  failureListOrderDataReport,
  clearListOrderDataReport,
} = ListOrderDataReport.actions;

export default ListOrderDataReport.reducer;
